// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./assets/stylesheets/partials/footer.scss
// module id = 440
// module chunks = 0